// @flow

import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import PageTitle from "../../../components/mui/app/pageTitle/pageTitle";
import PageContentWrapper from "../../../components/mui/general/pageContentWrapper/pageContentWrapper";
import { access_skills, access_user } from "../../../helpers/rights";
import { getRouteUrl } from "../../../helpers/routing/getRouteUrl";
import useQueryParams from "../../../hooks/useQueryParams";
import { withPermissionHOC } from "../../permission/components/permissionHOC/permissionHOC";
import { REPORTS } from "../locales/namespaces";
import { ROUTE_PAGE_REPORTS } from "../routes/routes";
import ProjectsReport from "./projectsReport";
import WorkersReport from "./workersReport";
import WorkersInProjects from "./workersInProjects";

type Props = {};

const Form = (props: Props) => {
	const { t } = useTranslation(REPORTS)
	const queryParams = useQueryParams()
	const section = queryParams.get('section') ?? "projects"
	
	return (
		<Box className={'projects_index'} sx={{ marginTop: '10px' }}>
			<PageContentWrapper>
				<PageTitle
					title={t('Reports')}/>
				<TabContext value={section}>
					<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
						<TabList aria-label="lab API tabs example">
							<Tab
								label={t('Projects')}
								value="projects"
								component={Link}
								to={getRouteUrl(ROUTE_PAGE_REPORTS, {}, {section: "projects"})}
							/>
							<Tab
								label={t('Workers')}
								value="workers"
								component={Link}
								to={getRouteUrl(ROUTE_PAGE_REPORTS, {}, {section: "workers"})}
							/>
							{/*<Tab*/}
							{/*	label={t('Workers time In Projects')}*/}
							{/*	value="workersInProjects"*/}
							{/*	component={Link}*/}
							{/*	to={getRouteUrl(ROUTE_PAGE_REPORTS, {}, {section: "workersInProjects"})}*/}
							{/*/>*/}
						</TabList>
					</Box>
					<TabPanel value="projects">
						<ProjectsReport/>
					</TabPanel>
					<TabPanel value="workers">
						<WorkersReport/>
					</TabPanel>
					{/*<TabPanel value="workersInProjects">*/}
					{/*	<WorkersInProjects/>*/}
					{/*</TabPanel>*/}
				</TabContext>
			</PageContentWrapper>
		</Box>
	
	);
};

// export default Form
export default withPermissionHOC(Form, [access_skills])